import * as content from '../content';
import { WORKING_OFF_ITEMS } from '../workingOffItems';
import { uiRu } from './uiRu';

export default {
  ...content,
  WORKING_OFF_ITEMS,
  ui: uiRu,
};
